import React, { lazy, Suspense } from "react";
const InsertDecorationModal = lazy(
  () => import("./insert-decoration-modal/insert-decoration-modal.js").then(
    ({ InsertDecorationModal: InsertDecorationModal2 }) => ({
      default: InsertDecorationModal2
    })
  )
);
const LineSpacingPanelComponent = (props) => /* @__PURE__ */ React.createElement(Suspense, { fallback: /* @__PURE__ */ React.createElement("div", { style: { width: 143 } }) }, /* @__PURE__ */ React.createElement(InsertDecorationModal, { ...props }));
var LineSpacingPanelComponent_default = LineSpacingPanelComponent;
export {
  LineSpacingPanelComponent_default as default
};
//# sourceMappingURL=LineSpacingPanelComponent.js.map
